import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AffiliateEventRequest } from 'src/app/models/affiliate.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AffiliateService } from 'src/app/services/affiliate.service';

@Component({
  selector: 'app-modal-affiliate-event',
  templateUrl: './modal-affiliate-event.component.html',
  styleUrls: ['./modal-affiliate-event.component.scss', '../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalAffiliateEventComponent implements OnInit{
  newEvent: AffiliateEventRequest = new AffiliateEventRequest();
  loading = false;
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private toastService: ToastrService,
    private affiliateService: AffiliateService
  ) {

  }

  ngOnInit(): void {
      
  }

  create(){
    var temp = new AffiliateEventRequest();
    temp.endDate = new Date(this.newEvent.endDate).getTime();
    temp.startDate = new Date(this.newEvent.startDate).getTime();
    temp.event = this.newEvent.event;
    temp.multiplier = this.newEvent.multiplier;
    this.loading = true;
    this.affiliateService.addEvent(temp).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Evento creado con éxito!");
        this.loading = false;
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }
}
